export default "/images/vendor/flag-icon-css/flags/1x1/hu.svg?7ae2a1f04ec537fbba4bea8c15126490";